import React from "react";
import { useAppDispatch, useAppSelector } from "../../store/hooks";

// Timesheet
import { useGetProjectedTimeQuery } from "../../services/Projects";
import {
  setProjectedSalarySheetTotalRecords,
  setProjectTimesheet,
  setProjectTimesheetError,
  setProjectTimesheetLoading,
} from "../../store/slices/projectSlice";

const Content = () => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);

  const state = useAppSelector((state) => state.project);

  const attendanceChange = useAppSelector(
    (state) => state.common.attendanceChange,
  );

  // **************
  // **************
  // Get Projected Timesheet Data
  // **************
  // **************
  const {
    data: projectedTimesheet,
    isLoading: projectedTimesheetLoading,
    isError: projectedTimesheetError,
    refetch: projectedTimesheetRefetch,
  } = useGetProjectedTimeQuery({
    accessToken: accessToken || "",
    userID: userID || "",
    permission: profileData.permissions.showPettyCash || false,
    projectId: state.projectedSalarySheet,
    page: state.projectedSalarySheetPageNo,
    limit: state.projectedSalarySheetPageSize,
    date: new Date(state.projectedSheetDate).toLocaleDateString(),
  });
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    if (projectedTimesheetLoading) {
      dispatch(setProjectTimesheetLoading(true));
    }
    if (projectedTimesheetError) {
      dispatch(setProjectTimesheetError("Something went wrong"));
      dispatch(setProjectTimesheetLoading(false));
    }
    if (projectedTimesheet) {
      dispatch(
        setProjectTimesheet(
          projectedTimesheet.data.salarySheetData[0].data || [],
        ),
      );
      dispatch(
        setProjectedSalarySheetTotalRecords(
          projectedTimesheet.data.salarySheetData[0].metadata[0]?.total || 0,
        ),
      );
      dispatch(setProjectTimesheetLoading(false));
    }
  }, [
    accessToken,
    userID,
    projectedTimesheet,
    profileData,
    state.projectedSalarySheetPageNo,
    state.projectedSalarySheetPageSize,
  ]);
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    projectedTimesheetRefetch();
  }, [state.projectedSalarySheet, attendanceChange]);
  return <></>;
};
export default Content;
